
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("8fb5x", function(module, exports) {

$parcel$export(module.exports, "EditorByLineArea", () => $d54487d18f54cde1$export$a5fad03eb2e226dc);
/* EditorByLineArea.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $ipPpS = parcelRequire("ipPpS");

var $5zuN8 = parcelRequire("5zuN8");

var $luv00 = parcelRequire("luv00");

var $9wGTI = parcelRequire("9wGTI");

var $eVxJD = parcelRequire("eVxJD");

var $9NQ2h = parcelRequire("9NQ2h");

var $7qnBP = parcelRequire("7qnBP");
const $d54487d18f54cde1$var$EditorByLineWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $d54487d18f54cde1$var$Spacer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_16jlkb7n",
            __cmplp.className
        ])
    });
});
const $d54487d18f54cde1$var$RightArea = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1txw _1tkexy5q _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $d54487d18f54cde1$export$a5fad03eb2e226dc = ({ contentId: contentId, contentType: contentType, isPublishingContent: isPublishingContent, userOffline: userOffline, editorAppearanceButton: editorAppearanceButton, isLivePage: isLivePage, isKnowledgeBaseSpace: isKnowledgeBaseSpace, viewMode: viewMode, editorApi: editorApi, isUnpublishedDraft: isUnpublishedDraft, isSpaceOverview: isSpaceOverview })=>{
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const { workflowStatus: workflowStatus } = (0, $9NQ2h.useWorkflowStatus)();
    if (isSpaceOverview) return null;
    if (isLivePage || (0, $9wGTI.fg)('cc_page_experiences_new_editor_byline')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($d54487d18f54cde1$var$EditorByLineWrapper, {
        "data-vc": "editor-byline-wrapper",
        ...ssrPlaceholderIdProp
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7qnBP.LivePagesByLine), {
        contentId: contentId,
        contentType: contentType,
        isPublishingContent: isPublishingContent,
        userOffline: userOffline,
        isKnowledgeBaseSpace: isKnowledgeBaseSpace,
        viewMode: viewMode,
        editorApi: editorApi,
        isUnpublishedDraft: isUnpublishedDraft
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($d54487d18f54cde1$var$EditorByLineWrapper, {
        "data-vc": "editor-byline-wrapper",
        ...ssrPlaceholderIdProp
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($d54487d18f54cde1$var$Spacer, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($d54487d18f54cde1$var$RightArea, {
        "data-testId": "editor-byline-right-area"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ipPpS.Subscribe), {
        to: [
            (0, $5zuN8.ContentStateStateContainer)
        ]
    }, (contentStateState)=>{
        // view mode users should not be able to edit the content state, so we just render the content state.
        if (viewMode) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5zuN8.RendererContentState), {
            contentId: contentId,
            hasSeparator: false,
            isDraft: true // this sets the query to use draft version over published version
        });
         // Replace Content State with a similar Workflow state container once a workflow has been selected.
        if (workflowStatus && (0, $9wGTI.fg)('document_workflows')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eVxJD.WorkflowStatusLoader), null);
         // Knowledge space pages without the new byline will always show the editable content state component in this area.
        // Other pages will only show the editable content state component if the content state is already set.
        // This is because a page without a content state is initialized by the ContentStateHoverButton component.
        return (contentStateState.state.contentState || isKnowledgeBaseSpace) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5zuN8.EditorContentState), {
            contentId: contentId,
            contentType: contentType,
            isPublishingContent: isPublishingContent,
            userOffline: userOffline
        });
    }), !viewMode && !(isSpaceOverview && (0, $9wGTI.fg)('cc_page_experiences_new_editor_byline')) && editorAppearanceButton)));
};

});
parcelRegister("9NQ2h", function(module, exports) {

$parcel$export(module.exports, "useWorkflowStatus", () => $741da7191586fe61$export$3070b9a24421340b);

var $j1Ss3 = parcelRequire("j1Ss3");

var $d2LG0 = parcelRequire("d2LG0");

var $ixUm0 = parcelRequire("ixUm0");

var $9wGTI = parcelRequire("9wGTI");

var $ep3mz = parcelRequire("ep3mz");

var $bQm3c = parcelRequire("bQm3c");
const $741da7191586fe61$var$useWorkflowStatusQuery = (0, $d2LG0.gql)`
	query useWorkflowStatusQuery($contentId: ID!) {
		confluence_workflowApplicationsByContentId(contentId: $contentId, first: 50) {
			nodes {
				currentWorkflowStatus {
					id
					displayProperties {
						name
						color
					}
				}
				availableTransitions {
					id
					displayProperties {
						name
						description
					}
					startStatus {
						displayProperties {
							name
						}
					}
					destinationStatus {
						displayProperties {
							name
						}
					}
				}
			}
		}
	}
`;
const $741da7191586fe61$export$3070b9a24421340b = ()=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const pageAri = contentId ? (0, $ixUm0.ConfluencePageAri).create({
        siteId: cloudId,
        pageId: contentId
    }).toString() : undefined;
    const { data: data, loading: loading, error: error } = (0, $j1Ss3.useQuery)($741da7191586fe61$var$useWorkflowStatusQuery, {
        skip: !pageAri || !(0, $9wGTI.fg)('document_workflows'),
        variables: {
            contentId: pageAri
        }
    });
    const workflowStatus = data?.confluence_workflowApplicationsByContentId?.nodes?.[0];
    return {
        workflowStatus: workflowStatus,
        loading: loading,
        error: error
    };
};

});

parcelRegister("7qnBP", function(module, exports) {

$parcel$export(module.exports, "LivePagesByLine", () => $d898e2893b08edbf$export$7ee26dfdd6e2e40f);

var $diswb = parcelRequire("diswb");

var $gwFzn = parcelRequire("gwFzn");

var $dIouf = parcelRequire("dIouf");

var $9wGTI = parcelRequire("9wGTI");

var $7Sm4c = parcelRequire("7Sm4c");

var $ep3mz = parcelRequire("ep3mz");

var $3jwuS = parcelRequire("3jwuS");

var $72lVk = parcelRequire("72lVk");

var $80xNa = parcelRequire("80xNa");

var $4J61X = parcelRequire("4J61X");

var $gaqtW = parcelRequire("gaqtW");

var $ausiN = parcelRequire("ausiN");

var $83fWZ = parcelRequire("83fWZ");
const $d898e2893b08edbf$export$7ee26dfdd6e2e40f = ({ contentId: contentId, contentType: contentType, viewMode: viewMode, isPublishingContent: isPublishingContent, isKnowledgeBaseSpace: isKnowledgeBaseSpace, userOffline: userOffline, editorApi: editorApi, isUnpublishedDraft: isUnpublishedDraft })=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const lastLoadedQueryData = (0, $gwFzn.useRef)(null);
    // eslint-disable-next-line prefer-const
    let { data: data, loading: loading, error: error } = (0, $diswb.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $72lVk.ContentHeaderUnifiedQuery), {
        variables: {
            contentId: contentId,
            spaceKey: spaceKey,
            // Don't omit versionOverride, embeddedContentRender and limit
            // It's an Apollo bug that if preloader these needs to be match preloaded query
            // Also doesn't work if removing them from preloader variables HOT-109035
            versionOverride: null,
            embeddedContentRender: null,
            limit: (0, $80xNa.DEFAULT_CONTRIBUTORS_FETCH_LIMIT),
            ...isUnpublishedDraft && !isLivePage && {
                status: [
                    'draft'
                ]
            }
        },
        context: {
            single: true
        },
        fetchPolicy: 'cache-and-network'
    });
    const renderByLine = ()=>{
        if (loading) {
            // If we're loading because the LivePagesByLineWithContributorsComponent called our
            // fetchAllContributors, then we should continue the render with data
            // cached from the previous query (the one with the low
            // contributorsFetchLimit). It's important to not bring the skeletons back
            // up, as that'd kill the opening of the dropdown.
            if (lastLoadedQueryData.current) data = lastLoadedQueryData.current;
            else return (0, $9wGTI.fg)('cc_page_experiences_live_pages_byline_placeholder') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ausiN.LivePagesByLinePlaceholderComponent), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4J61X.ByLinePlaceholder), null);
        } else if (!error) lastLoadedQueryData.current = data || null;
        const content = data?.content?.nodes?.[0];
        if (error) {
            if ((0, $dIouf.isUnauthorizedError)(error)) {
                (0, $7Sm4c.markErrorAsHandled)(error);
                return null;
            } else // TODO: unknown errors should have a nicer UI within `<ErrorDisplay>`, but we don't have such UI for now
            // so returning empty `<ErrorDisplay>` here.
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
                error: error
            });
        } else if (!content) return null;
        const contributorProps = $d898e2893b08edbf$export$6dbfb663651d0abf(content, data);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gaqtW.LivePagesByLineWithContributorsComponent), {
            ...contributorProps,
            contentId: contentId,
            contentType: contentType,
            viewMode: viewMode,
            isPublishingContent: isPublishingContent,
            isKnowledgeBaseSpace: isKnowledgeBaseSpace,
            userOffline: userOffline,
            editorApi: editorApi,
            isUnpublishedDraft: isUnpublishedDraft
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).PAGE_MODES
    }, renderByLine());
};
const $d898e2893b08edbf$export$6dbfb663651d0abf = (content, data)=>{
    const author = (0, $83fWZ.toUserProps)(content?.history?.createdBy);
    const owner = content?.history?.ownedBy && (content?.type === 'page' || content?.type === 'blogpost') ? (0, $83fWZ.toUserProps)(content?.history?.ownedBy) : null;
    const lastOwner = content?.history?.lastOwnedBy && (content?.type === 'page' || content?.type === 'blogpost') ? (0, $83fWZ.toUserProps)(content?.history?.lastOwnedBy) : null;
    const createdDateString = content?.history?.createdDate;
    const createdDate = createdDateString ? new Date(createdDateString) : null;
    const lastModifyUser = (0, $83fWZ.toUserProps)(content?.version?.by);
    const version = {
        friendlyWhen: content?.version?.friendlyWhen || '',
        number: Number(content?.version?.version || ''),
        by: lastModifyUser,
        contentTypeModified: content?.version?.contentTypeModified || false
    };
    const contributors = data?.contentContributors?.nodes?.map((0, $83fWZ.toUserProps)) || [];
    const contributorsCount = data?.contentContributors?.count || 0;
    const isOwnerContributor = data?.contentContributors?.isOwnerContributor;
    return {
        author: author,
        owner: owner,
        lastOwner: lastOwner,
        createdDate: createdDate,
        lastModifyUser: lastModifyUser,
        contributors: contributors,
        contributorsCount: contributorsCount,
        isOwnerContributor: isOwnerContributor,
        version: version
    };
};

});
parcelRegister("gaqtW", function(module, exports) {

$parcel$export(module.exports, "LivePagesByLineWithContributorsComponent", () => $3db5129918072e70$export$a6a69f624b6c8259);

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $ipPpS = parcelRequire("ipPpS");

var $diswb = parcelRequire("diswb");

var $6f0Oj = parcelRequire("6f0Oj");
var $bUlM5 = parcelRequire("bUlM5");
var $ecnYn = parcelRequire("ecnYn");

var $6mKj3 = parcelRequire("6mKj3");

var $5zuN8 = parcelRequire("5zuN8");

var $dIouf = parcelRequire("dIouf");

var $6S5EB = parcelRequire("6S5EB");

var $9wGTI = parcelRequire("9wGTI");

var $7om8k = parcelRequire("7om8k");
var $1xCGJ = parcelRequire("1xCGJ");

var $fs6LW = parcelRequire("fs6LW");
var $jJK3p = parcelRequire("jJK3p");

var $7QM6o = parcelRequire("7QM6o");

var $aE7dy = parcelRequire("aE7dy");

var $bnIxr = parcelRequire("bnIxr");

var $bth99 = parcelRequire("bth99");

var $3jwuS = parcelRequire("3jwuS");

var $blyhC = parcelRequire("blyhC");

var $j2moL = parcelRequire("j2moL");

var $dyWO6 = parcelRequire("dyWO6");

var $35Exc = parcelRequire("35Exc");

var $83fWZ = parcelRequire("83fWZ");

var $bNel4 = parcelRequire("bNel4");

var $aKxcs = parcelRequire("aKxcs");

var $6iOCg = parcelRequire("6iOCg");
const $3db5129918072e70$var$bylineAppsStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.100',
    font: 'font.body.small',
    display: 'inline'
});
const $3db5129918072e70$export$a6a69f624b6c8259 = /*#__PURE__*/ (0, $gwFzn.memo)(({ contentId: contentId, author: author, owner: owner, createdDate: createdDate, lastModifyUser: lastModifyUser, contributors: contributors, contributorsCount: contributorsCount, isOwnerContributor: isOwnerContributor, lastOwner: lastOwner, contentType: contentType, isPublishingContent: isPublishingContent, userOffline: userOffline, isKnowledgeBaseSpace: isKnowledgeBaseSpace, viewMode: viewMode, editorApi: editorApi, isUnpublishedDraft: isUnpublishedDraft })=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isExternalShare = (0, $6S5EB.isExternalShareRequest)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    const { hasApps: hasApps, connectItems: connectItems, forgeItems: forgeItems, forgeError: forgeError } = (0, $blyhC.useByLineApps)(contentId);
    const { data: data } = (0, $diswb.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $5zuN8.EditorContentStateQuery), {
        fetchPolicy: 'cache-first',
        variables: {
            contentId: contentId,
            isDraft: true
        },
        skip: !Boolean(window.__SSR_RENDERED__)
    });
    const getContributorsData = (0, $gwFzn.useMemo)(()=>{
        const arrangedContributors = (0, $83fWZ.getArrangedContributors)({
            owner: owner,
            author: author,
            lastModifier: lastModifyUser,
            contributors: contributors
        });
        const userToAvatarGroupDataItem = (user)=>({
                // Props for <ProfileAvatar>
                isAnonymous: user.isAnonymous,
                userId: user.userId,
                src: user.avatarUrl,
                // Extra props
                name: user.fullName
            });
        return [
            ...arrangedContributors// Actual data for the users we know about
            .map(userToAvatarGroupDataItem),
            // Skeletons for the ones we don't
            ...Array(Math.max(contributorsCount - arrangedContributors.length, 0)).fill(null).map(()=>({
                    src: (0, $dyWO6.png_1x1_n40),
                    name: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $35Exc.StyledNameSkeleton), null)
                }))
        ];
    }, [
        owner,
        author,
        lastModifyUser,
        contributors,
        contributorsCount
    ]);
    const pageOwnerOrFirstContributorData = getContributorsData[0];
    const contributorCountWithoutOwner = contributorsCount - (isOwnerContributor ? 1 : 0);
    const CreatorOrOwnerByline = (0, $gwFzn.useMemo)(()=>{
        if (owner !== null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1xCGJ.PageOwnershipByline), {
            owner: owner,
            creator: author,
            createdDate: createdDate,
            templateId: null,
            contentId: contentId,
            lastOwner: lastOwner
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
            id: "content-header.livepages.by-line.by.expanded",
            defaultMessage: "By {author}",
            values: {
                author: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $jJK3p.ProfileLink), {
                    userId: author.userId,
                    fullName: author.fullName,
                    isAnonymous: author.isAnonymous,
                    referralSource: "profilecard"
                })
            }
        });
    }, [
        author,
        owner,
        createdDate,
        contentId,
        lastOwner
    ]);
    const renderReactions = isLivePage || !isUnpublishedDraft;
    const singleLineOwnershipByline = !(0, $9wGTI.fg)('cc_page_experiences_byline_badge_style') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        alignItems: "center",
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fs6LW.ProfileAvatar), {
        src: pageOwnerOrFirstContributorData.src,
        userId: pageOwnerOrFirstContributorData.userId,
        isAnonymous: pageOwnerOrFirstContributorData.isAnonymous,
        name: pageOwnerOrFirstContributorData.name,
        size: "small",
        testId: "live-pages-byline-owner-or-first-contributor-avatar"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $35Exc.StyledAuthorDiv), null, CreatorOrOwnerByline)) : // reactions are larger than the owner item, so if we arent rending reactions (example: unpublished drafts), we need to add extra padding to avoid the placeholder being too large and causing a jump on load
    // ideally we will get reactions down to the same size as other items (24px) so we can remove this extra padding
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        paddingBlock: renderReactions || !(0, $9wGTI.fg)('cc-page-experiences-byline-ttvc-offender-fg') ? undefined : 'space.050'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7om8k.BadgeStylePageOwnershipByline), {
        owner: owner,
        author: author,
        analyticsSource: "liveDoc",
        contributorCountWithoutOwner: contributorCountWithoutOwner
    }));
    const ByLineCommonContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, (0, $9wGTI.fg)('cc_page_experiences_byline_classification') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $aKxcs.BylineClassification), {
        contentId: contentId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ipPpS.Subscribe), {
        to: [
            (0, $5zuN8.ContentStateStateContainer)
        ]
    }, (contentStateState)=>{
        // view mode users should not be able to edit the content state, so we just render the content state.
        if (viewMode) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5zuN8.RendererContentState), {
            contentId: contentId,
            hasSeparator: false,
            isDraft: !isLivePage
        });
        // Knowledge space live pages will always show the editable content state component.
        // Other live pages will only show the editable content state component if the content state is already set.
        // This is because a page without a content state is initialized by the ContentStateHoverButton component.
        // SSRd content state will have it's value in gql cache initially instead of the unstated store
        const isSSRRenderedOnLoad = Boolean(data?.singleContent?.contentState) && Boolean(window.__SSR_RENDERED__) && contentStateState.state.shouldRunContentStateEffect;
        if (contentStateState.state.contentState || isKnowledgeBaseSpace || isSSRRenderedOnLoad) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5zuN8.EditorContentState), {
            contentId: contentId,
            contentType: contentType,
            isPublishingContent: isPublishingContent,
            userOffline: userOffline,
            floatingToolbarButtonStyle: {
                alignItems: 'center',
                height: '24px'
            }
        });
        else return null;
    }), isLivePage && !(0, $9wGTI.fg)('confluence_frontend_object_header') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bNel4.LivePagesByLineLastUpdated), {
        contentId: contentId,
        editorApi: editorApi
    }), (0, $9wGTI.fg)('live_pages_byline_read_time') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bth99.ReadTime), {
        contentId: contentId,
        editorApi: editorApi,
        isInEditor: true
    }), (isLivePage || !isUnpublishedDraft) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bnIxr.AnalyticsByLine), {
        contentId: contentId,
        contentAuthorId: author.userId
    }), renderReactions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $aE7dy.LivePagesByLineReactions), {
        contentId: contentId,
        spaceId: spaceId || '',
        isDisabled: userOffline && (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false),
        isContentCreationPanelOpen: true,
        isSubtle: true,
        contentType: contentType
    }));
    if ((0, $9wGTI.fg)('confluence_frontend_single_line_byline_live_pages')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6iOCg.SingleLineByLine), {
        contentId: contentId,
        contentType: contentType
    }, singleLineOwnershipByline, ByLineCommonContent);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        direction: "column",
        testId: "live-pages-byline-multi-line"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $35Exc.LivePagesBylineStyledMainDiv), {
        hasFixedHeight: (0, $9wGTI.fg)('cc_page_experiences_live_pages_byline_placeholder')
    }, !(0, $9wGTI.fg)('cc_page_experiences_byline_badge_style') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $35Exc.StyledAvatars), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fs6LW.ProfileAvatar), {
        src: pageOwnerOrFirstContributorData.src,
        userId: pageOwnerOrFirstContributorData.userId,
        isAnonymous: pageOwnerOrFirstContributorData.isAnonymous,
        name: pageOwnerOrFirstContributorData.name,
        size: "small",
        testId: "live-pages-byline-owner-or-first-contributor-avatar"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $35Exc.BylineStyledTextDiv), {
        "data-testId": "byline-text-component",
        hasBadgeStylePageOwnerBylineItem: (0, $9wGTI.fg)('cc_page_experiences_byline_badge_style')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        gap: "space.075",
        justifyContent: "center",
        alignItems: "center"
    }, !(0, $9wGTI.fg)('cc_page_experiences_byline_badge_style') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $35Exc.StyledAuthorDiv), null, CreatorOrOwnerByline) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7om8k.BadgeStylePageOwnershipByline), {
        owner: owner,
        author: author,
        analyticsSource: isLivePage ? 'liveDoc' : 'editor',
        contributorCountWithoutOwner: contributorCountWithoutOwner
    }), ByLineCommonContent))), !isExternalShare && hasApps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        alignItems: "center",
        xcss: $3db5129918072e70$var$bylineAppsStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).ECOSYSTEM
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $j2moL.LazyLivePagesByLineApps), {
        contentId: contentId,
        connectItems: connectItems,
        forgeItems: forgeItems,
        forgeError: forgeError,
        showLivePagesExtensionPoints: true
    }))));
});

});
parcelRegister("aE7dy", function(module, exports) {

$parcel$export(module.exports, "LivePagesByLineReactions", () => $06f66a283e23582e$export$37ba4ba009bc421f);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $4FHTF = parcelRequire("4FHTF");

var $2ttXz = parcelRequire("2ttXz");

var $83sfO = parcelRequire("83sfO");

var $3jwuS = parcelRequire("3jwuS");

var $9wGTI = parcelRequire("9wGTI");

var $1NF8X = parcelRequire("1NF8X");

var $6mKj3 = parcelRequire("6mKj3");
const $06f66a283e23582e$var$i18n = (0, $2nPZH.defineMessages)({
    addNew: {
        id: "live-pages-features.byline.reactions.add.new",
        defaultMessage: "Add new"
    },
    addReaction: {
        id: "live-pages-features.byline.reactions.add.reaction",
        defaultMessage: "Add reaction"
    }
});
const $06f66a283e23582e$var$templateSidebarWidth = 320;
const $06f66a283e23582e$var$floatingContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    position: 'fixed',
    justifyContent: 'right',
    bottom: 'space.300',
    right: 'space.100',
    zIndex: 'layer',
    transition: 'left 600ms'
});
const $06f66a283e23582e$var$subtleReactionsFloatingContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    justifyContent: 'left',
    transition: 'left 600ms',
    marginBottom: 'space.025',
    height: '28px'
});
const $06f66a283e23582e$var$containerStylesWhenPanelOpen = (0, $ecnYn.xcss)({
    paddingRight: 'space.100',
    right: `${$06f66a283e23582e$var$templateSidebarWidth}px`,
    transition: 'right 600ms'
});
const $06f66a283e23582e$var$topMargin = (0, $ecnYn.xcss)({
    marginTop: 'space.025'
});
const $06f66a283e23582e$export$37ba4ba009bc421f = ({ contentId: contentId, spaceId: spaceId, isDisabled: isDisabled = false, isContentCreationPanelOpen: isContentCreationPanelOpen, isSubtle: isSubtle, contentType: contentType })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    // Used when we want to allow the user to select reactions from the summary view popup
    const customIcon = (0, $9wGTI.fg)('confluence_page_reactions_ga_changes') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4FHTF))), {
        testId: "emoji-add-icon",
        color: "var(--ds-icon-subtle, #626F86)",
        label: formatMessage($06f66a283e23582e$var$i18n.addReaction)
    }) : undefined;
    const reactionPickerText = (0, $9wGTI.fg)('confluence_page_reactions_ga_changes') ? formatMessage($06f66a283e23582e$var$i18n.addNew) : undefined;
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = Boolean((0, window.__SSR_RENDERED__));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: [
            isSubtle ? $06f66a283e23582e$var$subtleReactionsFloatingContainerStyles : $06f66a283e23582e$var$floatingContainerStyles,
            isContentCreationPanelOpen && $06f66a283e23582e$var$containerStylesWhenPanelOpen,
            $06f66a283e23582e$var$topMargin
        ],
        testId: "live-pages-reactions"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1NF8X.ReactionsLoader), {
        contentId: contentId,
        location: contentType === 'blogpost' ? (0, $2ttXz.ReactionLocation).BLOGPOST : (0, $2ttXz.ReactionLocation).PAGE,
        containerId: spaceId,
        containerType: (0, $2ttXz.ReactionContainerType).SPACE,
        contentSubType: isLivePage ? (0, $83sfO.LIVE_PAGE_SUBTYPE) : null,
        summaryViewEnabled: true,
        summaryViewThreshold: 1,
        allowSelectFromSummaryView: (0, $9wGTI.fg)('confluence_page_reactions_ga_changes'),
        useButtonAlignmentStyling: true,
        summaryViewPlacement: "bottom-start",
        hideNoReactionsText: true,
        readOnly: isDisabled,
        isViewOnly: (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false) && isDisabled,
        isSubtle: isSubtle,
        reactionPickerTriggerIcon: customIcon,
        reactionPickerTriggerText: reactionPickerText,
        useDefaultStyledContainer: true,
        hidePlaceholder: isSSR,
        noRelativeContainer: (0, $9wGTI.fg)('confluence_frontend_single_line_byline_live_pages'),
        noFlexWrap: (0, $9wGTI.fg)('confluence_frontend_single_line_byline_live_pages'),
        hoverableSummaryView: (0, $9wGTI.fg)('confluence_page_reactions_ga_changes'),
        optimisticallyLoadSummaryEmojis: isSSR
    }));
};

});
parcelRegister("83sfO", function(module, exports) {

$parcel$export(module.exports, "LIVE_PAGE_SUBTYPE", () => $567f280605647fdf$export$5d4c19aec4201e9);
const $567f280605647fdf$export$5d4c19aec4201e9 = 'live';

});


parcelRegister("bnIxr", function(module, exports) {

$parcel$export(module.exports, "AnalyticsByLine", () => $8e265cb10d523fc8$export$d0aef4d352cf8b14);
$parcel$export(module.exports, "SpaceAnalyticsPageLoader", () => $8e265cb10d523fc8$export$5c0ffde074fc4758);
$parcel$export(module.exports, "PageAnalyticsPageLoader", () => $8e265cb10d523fc8$export$1c22a22c4bc3d8e9);
$parcel$export(module.exports, "SiteAnalyticsPageLoader", () => $8e265cb10d523fc8$export$5d828b79b8aa9d27);
$parcel$export(module.exports, "SitePermissionsPageLoader", () => $8e265cb10d523fc8$export$6dd852c6aabadfda);

var $jmjWc = parcelRequire("jmjWc");

const $8e265cb10d523fc8$export$d0aef4d352cf8b14 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Z8mis",
    name: "AnalyticsByLine",
    loader: async ()=>(await (parcelRequire("h0dzm"))).AnalyticsByLine
});

const $8e265cb10d523fc8$export$5c0ffde074fc4758 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "B2ctB",
    name: "SpaceAnalyticsPageLoader",
    loader: async ()=>(await (parcelRequire("5iaBp"))).SpaceAnalyticsPage
});

const $8e265cb10d523fc8$export$1c22a22c4bc3d8e9 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "peBvZ",
    name: "PageAnalyticsPageLoader",
    loader: async ()=>(await (parcelRequire("jtjoc"))).PageAnalyticsPage
});

const $8e265cb10d523fc8$export$5d828b79b8aa9d27 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "1tHym",
    name: "SiteAnalyticsPageLoader",
    loader: async ()=>(await (parcelRequire("VukW5"))).SiteAnalyticsPage
});

const $8e265cb10d523fc8$export$6dd852c6aabadfda = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "FqJCu",
    name: "SitePermissionsPageLoader",
    loader: async ()=>(await (parcelRequire("cGKE5"))).SitePermissionsPage
});

});
parcelRegister("h0dzm", function(module, exports) {

let $c60cf656460a1d32$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $c60cf656460a1d32$var$load("hXFaG"),
    $c60cf656460a1d32$var$load("5hFEw"),
    $c60cf656460a1d32$var$load("7YFVd"),
    $c60cf656460a1d32$var$load("dVstB"),
    $c60cf656460a1d32$var$load("amDM8"),
    $c60cf656460a1d32$var$load("ftJgg"),
    $c60cf656460a1d32$var$load("6c9wI")
]).then(()=>parcelRequire('ffp8s'));

});

parcelRegister("5iaBp", function(module, exports) {

let $3da6db9b0acafd8e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $3da6db9b0acafd8e$var$load("dH2J7"),
    $3da6db9b0acafd8e$var$load("dVstB"),
    $3da6db9b0acafd8e$var$load("lcO7d"),
    $3da6db9b0acafd8e$var$load("amDM8"),
    $3da6db9b0acafd8e$var$load("hXFaG"),
    $3da6db9b0acafd8e$var$load("5hFEw"),
    $3da6db9b0acafd8e$var$load("gLxW3"),
    $3da6db9b0acafd8e$var$load("c6MKV"),
    $3da6db9b0acafd8e$var$load("keSaw"),
    $3da6db9b0acafd8e$var$load("bYnOS")
]).then(()=>parcelRequire('3EzW0'));

});

parcelRegister("jtjoc", function(module, exports) {

let $e2cfc416eacd4d15$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $e2cfc416eacd4d15$var$load("aZVDW"),
    $e2cfc416eacd4d15$var$load("dH2J7"),
    $e2cfc416eacd4d15$var$load("dVstB"),
    $e2cfc416eacd4d15$var$load("gYJBG"),
    $e2cfc416eacd4d15$var$load("67lYr"),
    $e2cfc416eacd4d15$var$load("amDM8"),
    $e2cfc416eacd4d15$var$load("e08m0"),
    $e2cfc416eacd4d15$var$load("hXFaG"),
    $e2cfc416eacd4d15$var$load("5hFEw"),
    $e2cfc416eacd4d15$var$load("ftJgg"),
    $e2cfc416eacd4d15$var$load("gLxW3"),
    $e2cfc416eacd4d15$var$load("keSaw"),
    $e2cfc416eacd4d15$var$load("2w2Fa"),
    $e2cfc416eacd4d15$var$load("9QvHa"),
    $e2cfc416eacd4d15$var$load("3ooAX"),
    $e2cfc416eacd4d15$var$load("4lfDj"),
    $e2cfc416eacd4d15$var$load("kUAIU"),
    $e2cfc416eacd4d15$var$load("dTsOE"),
    $e2cfc416eacd4d15$var$load("5SiDe"),
    $e2cfc416eacd4d15$var$load("c6MKV"),
    $e2cfc416eacd4d15$var$load("9uNix"),
    $e2cfc416eacd4d15$var$load("6sFkE")
]).then(()=>parcelRequire('1T0Cv'));

});

parcelRegister("VukW5", function(module, exports) {

let $0accdb37c3be379b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $0accdb37c3be379b$var$load("dH2J7"),
    $0accdb37c3be379b$var$load("dVstB"),
    $0accdb37c3be379b$var$load("gYJBG"),
    $0accdb37c3be379b$var$load("lcO7d"),
    $0accdb37c3be379b$var$load("amDM8"),
    $0accdb37c3be379b$var$load("hXFaG"),
    $0accdb37c3be379b$var$load("5hFEw"),
    $0accdb37c3be379b$var$load("gLxW3"),
    $0accdb37c3be379b$var$load("c6MKV"),
    $0accdb37c3be379b$var$load("keSaw"),
    $0accdb37c3be379b$var$load("hLE8r")
]).then(()=>parcelRequire('9Gz8W'));

});

parcelRegister("cGKE5", function(module, exports) {

let $93cd971df016dcbe$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $93cd971df016dcbe$var$load("amDM8"),
    $93cd971df016dcbe$var$load("2sCab")
]).then(()=>parcelRequire('3GuAz'));

});


parcelRegister("bNel4", function(module, exports) {

$parcel$export(module.exports, "LivePagesByLineLastUpdated", () => $dce34ae8b4376c02$export$e4a26074619839f4);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $diswb = parcelRequire("diswb");

var $2jjxD = parcelRequire("2jjxD");

var $inPa6 = parcelRequire("inPa6");

var $6qdjm = parcelRequire("6qdjm");

var $3gadb = parcelRequire("3gadb");

var $dIouf = parcelRequire("dIouf");

var $7Sm4c = parcelRequire("7Sm4c");

var $bQm3c = parcelRequire("bQm3c");

var $6iSKO = parcelRequire("6iSKO");

var $AavAW = parcelRequire("AavAW");
const $dce34ae8b4376c02$var$i18n = (0, $2nPZH.defineMessages)({
    recentFriendlyWhen: {
        id: "content-header.by-line.live-pages.last.updated.friendly.just.now",
        defaultMessage: "Just now"
    },
    tooltipWhen: {
        id: "content-header.by-line.live-pages.last.updated.tooltip",
        defaultMessage: "Last updated: {day} at {time}"
    }
});
const $dce34ae8b4376c02$export$e4a26074619839f4 = /*#__PURE__*/ (0, $gwFzn.memo)(({ contentId: contentId, editorApi: editorApi })=>{
    const { data: data, error: error, loading: loading, refetch: refetch } = (0, $diswb.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $6iSKO.ByLineLastUpdatedQuery), {
        variables: {
            contentId: contentId
        },
        notifyOnNetworkStatusChange: true,
        // sets loading to true when refetching, necessary for tooltip
        fetchPolicy: window.__SSR_RENDERED__ ? 'cache-first' : 'cache-and-network' // query is preloaded on SSR, but not for SPA
    });
    const latestVersion = data?.content?.nodes?.[0]?.version;
    // We need version in a state variable separate from query data, in order to set it on debouncedSetRecentVersion
    const [version, setVersion] = (0, $gwFzn.useState)({
        friendlyWhen: latestVersion?.friendlyWhen || null,
        when: latestVersion?.when || null
    });
    const previousRemoteChangeTimeRef = (0, $gwFzn.useRef)(undefined);
    const previousLocalChangeTimeRef = (0, $gwFzn.useRef)(undefined);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { locale: locale } = (0, $bQm3c.useSessionData)();
    const intl = (0, $dBxQj.default)();
    // Medium dateStyle does not support 'at' combiner, so we're using separate date/time formatters
    const dayFormatter = Intl.DateTimeFormat(locale, {
        dateStyle: 'medium'
    });
    const timeFormatter = Intl.DateTimeFormat(locale, {
        timeStyle: 'short'
    });
    (0, $gwFzn.useEffect)(()=>{
        // Only show the latest version, which could be from the query or from debouncedSetRecentVersion
        if (latestVersion && JSON.stringify(latestVersion) !== JSON.stringify(version) && latestVersion.when && latestVersion.when >= (version?.when ?? '0')) setVersion(latestVersion);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- we only want to trigger this on data change
    }, [
        latestVersion
    ]);
    // Fetch that is immediately invoked before the debounced wait period
    // Used on visibility change (when user switches to this tab) and mouseenter
    const debouncedLeadingFetch = (0, $gwFzn.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($2jjxD)))(refetch, 60000, {
            leading: true,
            trailing: false,
            maxWait: 60000
        }), [
        refetch
    ]);
    (0, $gwFzn.useEffect)(()=>{
        // Fetch last updated time when tab is focused
        const handleVisibilityChange = async ()=>{
            if (document.visibilityState === 'visible') debouncedLeadingFetch(); // Get latest value when user switches back to this tab
        };
        window.addEventListener('visibilitychange', handleVisibilityChange);
        return ()=>{
            window.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [
        debouncedLeadingFetch
    ]);
    // After a page edit, we know the last change was very recent, so we directly set the version and skip
    // fetching over the network. We still debounce this to avoid rapid calls and prevent perfromance lag
    // when a user starts typing on very large pages
    const debouncedSetRecentVersion = (0, $gwFzn.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($2jjxD)))(()=>{
            setVersion({
                friendlyWhen: intl.formatMessage($dce34ae8b4376c02$var$i18n.recentFriendlyWhen),
                when: new Date().toISOString()
            });
        }, 3000), [
        setVersion,
        intl
    ]);
    // Update time stamp to "Just now" on page edit
    (0, $6qdjm.usePluginStateEffect)(editorApi, [
        'collabEdit'
    ], ({ collabEditState: collabEditState })=>{
        const lastRemoteChangeTime = collabEditState?.initialised?.lastRemoteOrganicBodyChangeAt;
        const lastLocalChangeTime = collabEditState?.initialised?.lastLocalOrganicBodyChangeAt;
        const hasRemoteChanged = lastRemoteChangeTime && lastRemoteChangeTime !== previousRemoteChangeTimeRef.current;
        const hasLocalChanged = lastLocalChangeTime && lastLocalChangeTime !== previousLocalChangeTimeRef.current;
        if (hasRemoteChanged || hasLocalChanged) {
            previousRemoteChangeTimeRef.current = lastRemoteChangeTime;
            previousLocalChangeTimeRef.current = lastLocalChangeTime;
            debouncedSetRecentVersion();
        }
    });
    // Cancel any pending timers on unmount
    (0, $gwFzn.useEffect)(()=>{
        return ()=>{
            debouncedLeadingFetch.cancel();
            debouncedSetRecentVersion.cancel();
        };
    }, [
        debouncedLeadingFetch,
        debouncedSetRecentVersion
    ]);
    const tooltipContent = (0, $gwFzn.useMemo)(()=>{
        if (loading) return null;
        else if (version?.when) {
            // When time since last update is > 48 hours ago, friendlyWhen will be a date (i.e. Oct 31, 2024)
            // However, user time zone conversion of the friendlyWhen date is not currently working on the BE,
            // which means the localized date in the tooltip can differ from the UTC date in the byline.
            // To fix this discrepancy, for now we'll not show the tooltip for dates > 48 hours
            const date = new Date(version?.when);
            const twoDaysInMillis = 172800000;
            if (Date.now() - date.getTime() > twoDaysInMillis) return null;
            else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
                ...$dce34ae8b4376c02$var$i18n.tooltipWhen,
                values: {
                    day: dayFormatter.format(date),
                    time: timeFormatter.format(date)
                }
            });
        }
    }, [
        loading,
        version?.when,
        dayFormatter,
        timeFormatter
    ]);
    if (error) {
        if ((0, $dIouf.isUnauthorizedError)(error)) {
            (0, $7Sm4c.markErrorAsHandled)(error);
            return null;
        } else // TODO: unknown errors should have a nicer UI within `<ErrorDisplay>`, but we don't have such UI for now
        // so returning empty `<ErrorDisplay>` here.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
            error: error
        });
    }
    const handleTooltipShow = ()=>{
        debouncedLeadingFetch();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'LivePagesByLineLastUpdated',
                action: 'displayed',
                actionSubject: 'tooltip',
                actionSubjectId: 'bylineLastUpdate',
                attributes: {
                    contentId: contentId,
                    isLivePage: true
                }
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
        content: tooltipContent,
        onShow: handleTooltipShow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $AavAW.ByLineLastUpdatedCompact), {
        version: version,
        loading: loading
    }));
});

});




parcelRegister("g3p2i", function(module, exports) {

$parcel$export(module.exports, "SitePermissionType", () => $fc6a2e7c662c45f6$export$8995abb8169b2cb8);
$parcel$export(module.exports, "SitePermissionTypeFilter", () => $fc6a2e7c662c45f6$export$3347a7c058a0368a);
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $fc6a2e7c662c45f6$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
var $fc6a2e7c662c45f6$export$3347a7c058a0368a = /*#__PURE__*/ function(SitePermissionTypeFilter) {
    SitePermissionTypeFilter["ALL"] = "ALL";
    SitePermissionTypeFilter["EXTERNALCOLLABORATOR"] = "EXTERNALCOLLABORATOR";
    SitePermissionTypeFilter["NONE"] = "NONE";
    return SitePermissionTypeFilter;
}({});

});

parcelRegister("hpRYU", function(module, exports) {

$parcel$export(module.exports, "UserAndGroupSearchPicker", () => $4cbf051190fe8573$export$ca514d5352bb0171);
/* UserAndGroupSearchPicker.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * @graphql cc
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $d2LG0 = parcelRequire("d2LG0");

var $j1Ss3 = parcelRequire("j1Ss3");

var $4jR19 = parcelRequire("4jR19");

var $kSKAi = parcelRequire("kSKAi");

var $7rus4 = parcelRequire("7rus4");

var $bQm3c = parcelRequire("bQm3c");

var $dIouf = parcelRequire("dIouf");

var $kr1Wj = parcelRequire("kr1Wj");

var $7Sm4c = parcelRequire("7Sm4c");

var $jjoF2 = parcelRequire("jjoF2");

var $g3p2i = parcelRequire("g3p2i");
const $4cbf051190fe8573$var$MIN_SEARCH_LENGTH = 2;
const $4cbf051190fe8573$export$1434adfffc17371d = 200;
function $4cbf051190fe8573$export$e11674744930cd15(error) {
    if ('statusCode' in error && error['statusCode'] === 403 || error.message?.includes('403') || error.message?.includes('not allowed')) return true;
    return false;
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4cbf051190fe8573$var$DefaultWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1f1u1ylp _4g2iv77o _pfyjv77o",
            __cmplp.className
        ])
    });
});
const $4cbf051190fe8573$export$fd4159eb872f73c6 = ({ appearance: appearance, fieldId: fieldId, client: client, isMulti: isMulti, includeGroup: includeGroup, onSelect: onSelect, onChange: onChange, onClear: onClear, onFocus: onFocus, onBlur: onBlur, onOpen: onOpen, onClose: onClose, onInputChange: onInputChange, onKeyDown: onKeyDown, filterSearchResults: filterSearchResults, smartFilterOptions: smartFilterOptions, value: value, defaultValue: defaultValue, noOptionsMessage: noOptionsMessage, addMoreMessage: addMoreMessage, menuPortalTarget: menuPortalTarget, autoFocus: autoFocus, width: width, maxPickerHeight: maxPickerHeight, smart: smart, styles: styles, placeholder: placeholder, sitePermissionTypeFilter: sitePermissionTypeFilter = (0, $g3p2i.SitePermissionTypeFilter).NONE, allowEmail: allowEmail, includeTeams: includeTeams, menuPosition: menuPosition, customInclusion: customInclusion = [], ariaLabel: ariaLabel, ariaDescribedBy: ariaDescribedBy, role: role, isDisabled: isDisabled = false, isLoading: isLoading = false, bootstrapOptions: bootstrapOptions = [], inputId: inputId, withUsers: withUsers = true, Wrapper: Wrapper = $4cbf051190fe8573$var$DefaultWrapper, header: header, open: open, userpickerDescribedbyId: userpickerDescribedbyId })=>{
    const [error, setError] = (0, $gwFzn.useState)(undefined);
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const { loading: searchPickerLoading, data: searchPickerData } = (0, $j1Ss3.useQuery)((0, $d2LG0.default)`query UserAndGroupSearchPickerQuery{entitlements{externalCollaborator{isEntitled}}}`);
    const handleError = (searchError)=>{
        if (searchError) {
            setError(searchError); // mark error as handled so we don't have ui unhandled errors
            (0, $7Sm4c.markErrorAsHandled)(searchError);
        }
    };
    const promiseOptions = (searchTerm)=>!searchTerm || searchTerm.length < $4cbf051190fe8573$var$MIN_SEARCH_LENGTH ? [] : (0, $jjoF2.userGroupSearchPromise)({
            searchTerm: searchTerm,
            client: client,
            includeGroup: includeGroup,
            customInclusion: customInclusion,
            setError: setError,
            filterResults: filterSearchResults,
            sitePermissionTypeFilter: sitePermissionTypeFilter,
            withUsers: withUsers
        });
    const searchErrorMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        id: "user-and-group-search.search.error" // TODO: replace straight quotes with curly quotes (see go/curlyquotes)
        ,
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "Sorry, we're having trouble loading search results right now."
    });
    const permissionErrorMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        id: "user-and-group-search.permission.error" // TODO: replace straight quotes with curly quotes (see go/curlyquotes)
        ,
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "We couldn't find any results because you don't have permission to search the user directory."
    }); // TODO: <UserPicker> expects `noOptionsMessage` to return string | null
    // but this callback returns JSX.Element | string | null, so error message must be string.
    const emptyResultsMessage = (input)=>{
        if (error) {
            if ($4cbf051190fe8573$export$e11674744930cd15(error)) return permissionErrorMessage;
            return searchErrorMessage;
        } else if (typeof noOptionsMessage === 'function') return noOptionsMessage(input);
        return noOptionsMessage;
    };
    const isEntitledExternalCollaboration = (0, $kr1Wj.getExternalCollaboratorEntitlementFromQuery)(searchPickerData) ?? false;
    const finalPlaceholder = placeholder || (includeGroup ? allowEmail ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        id: "user-and-group-search.placeholder.text.users.groups.and.email",
        defaultMessage: "Add people by name, email, or group"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        id: "user-and-group-search.placeholder.text.users.and.groups" // TODO: a content designer should check this case. This isn't the usual sentence structure for placeholders.
        ,
        defaultMessage: "Type a user name or group"
    }) : allowEmail ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        id: "user-and-group-search.placeholder.text.users.and.email",
        defaultMessage: "Add people, emails"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        id: "user-and-group-search.placeholder.text.users" // TODO: a content designer should check this case. This isn't the usual sentence structure for placeholders.
        ,
        defaultMessage: "Type a user name"
    }));
    const commonProps = {
        appearance: appearance,
        placeholder: finalPlaceholder,
        addMoreMessage: addMoreMessage,
        isMulti: isMulti,
        defaultValue: defaultValue,
        fieldId: fieldId,
        menuPortalTarget: menuPortalTarget,
        noOptionsMessage: emptyResultsMessage,
        onChange: onChange,
        onClear: onClear,
        onFocus: onFocus,
        onOpen: onOpen,
        onClose: onClose,
        onInputChange: onInputChange,
        onSelection: onSelect,
        value: value,
        width: width,
        maxPickerHeight: maxPickerHeight,
        allowEmail: allowEmail,
        styles: styles,
        menuPosition: menuPosition,
        isDisabled: isDisabled,
        inputId: inputId,
        withUsers: withUsers,
        header: header,
        open: open,
        'aria-labelledby': `react-select-${fieldId}-placeholder`,
        'aria-describedby': userpickerDescribedbyId
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Wrapper, {
        "aria-label": ariaLabel,
        "aria-describedby": ariaDescribedBy,
        role: role
    }, error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
        error: error
    }) : null, !smart && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kSKAi.UserPicker), {
        ...commonProps,
        inputId: inputId,
        autoFocus: autoFocus,
        loadOptions: promiseOptions,
        onBlur: onBlur,
        isLoading: isLoading,
        appearance: appearance
    }), smart && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7rus4.default), {
        ...commonProps,
        inputId: inputId,
        debounceTime: $4cbf051190fe8573$export$1434adfffc17371d,
        includeGroups: includeGroup,
        isLoading: searchPickerLoading || isLoading,
        maxOptions: 60,
        onError: handleError,
        filterOptions: smartFilterOptions,
        productAttributes: {
            isEntitledConfluenceExternalCollaborator: isEntitledExternalCollaboration
        },
        principalId: "context" // infer principal ID from UCT
        ,
        productKey: "confluence" // eslint-disable-next-line jsx-a11y/no-autofocus
        ,
        autoFocus: autoFocus,
        siteId: cloudId,
        orgId: orgId,
        includeTeams: includeTeams,
        bootstrapOptions: bootstrapOptions,
        onBlur: onBlur,
        onKeyDown: onKeyDown
    }));
};
const $4cbf051190fe8573$export$ca514d5352bb0171 = (0, $j1Ss3.withApollo)($4cbf051190fe8573$export$fd4159eb872f73c6);

});
parcelRegister("jjoF2", function(module, exports) {

$parcel$export(module.exports, "userGroupSearchPromise", () => $9d3a4572140e810a$export$c139484855007019);

var $9fywD = parcelRequire("9fywD");

var $11dKl = parcelRequire("11dKl");

var $9eE57 = parcelRequire("9eE57");

var $g3p2i = parcelRequire("g3p2i");

var $6RGMW = parcelRequire("6RGMW");
const $9d3a4572140e810a$export$c139484855007019 = ({ searchTerm: searchTerm, client: client, includeGroup: includeGroup, customInclusion: customInclusion, setError: setError, sitePermissionTypeFilter: sitePermissionTypeFilter, filterResults: filterResults, withUsers: withUsers })=>{
    const subject = 'userAndGroupSearchQuery';
    (0, $9eE57.perfMarkStart)({
        subject: subject
    });
    return client.query({
        query: (0, $6RGMW.UserAndGroupSearchQuery),
        variables: {
            withGroups: includeGroup,
            searchTerm: searchTerm,
            sitePermissionTypeFilter: sitePermissionTypeFilter,
            withUsers: withUsers
        }
    }).then(({ data: data })=>{
        const { users: users = [], groups: groups = [] } = data.userGroupSearch;
        const userList = users.map((item)=>({
                id: `user-${item.accountId}`,
                name: item.displayName,
                extra: item,
                type: 'user',
                avatarUrl: item.profilePicture ? item.profilePicture.path : '',
                lozenge: item.permissionType === (0, $g3p2i.SitePermissionType).EXTERNAL ? (0, $9fywD.ExternalUserLozengeProps) : null
            }));
        const groupList = groups.map((item)=>({
                id: `group-${item.id}`,
                name: item.name,
                type: 'group',
                extra: item,
                lozenge: item.permissionType === (0, $g3p2i.SitePermissionType).EXTERNAL ? (0, $11dKl.ExternalGroupLozengeProps) : null
            }));
        const customInclusionList = [];
        const cleanedSearchTerm = searchTerm.replace(/\s/g, '').toLowerCase();
        customInclusion.forEach((inclusionObj)=>{
            Object.keys(inclusionObj).forEach((key)=>{
                if (key.toLowerCase().startsWith(cleanedSearchTerm)) customInclusionList.push(inclusionObj[key]);
            });
        });
        const usersGroupsAndAccessClasses = [
            ...customInclusionList,
            ...userList,
            ...groupList
        ];
        (0, $9eE57.perfMarkEnd)({
            subject: subject
        });
        return filterResults ? usersGroupsAndAccessClasses.filter(filterResults) : usersGroupsAndAccessClasses;
    }).catch((error)=>{
        setError(error);
        return [];
    });
};

});
parcelRegister("11dKl", function(module, exports) {

$parcel$export(module.exports, "ExternalGroupLozengeProps", () => $f9006b515271a00f$export$fef38ba78dbe85a6);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $aIk0I = parcelRequire("aIk0I");

var $3gadb = parcelRequire("3gadb");
const $f9006b515271a00f$var$i18n = (0, $2nPZH.defineMessages)({
    externalGroupLozengeText: {
        id: "external-collab-ui.group-guest-lozenge",
        defaultMessage: "Guest"
    },
    externalGroupTooltip: {
        id: "external-collab-ui.group-guest-lozenge.tooltip",
        defaultMessage: "Guest groups can only access certain spaces and have limited access to user info."
    }
});
const $f9006b515271a00f$export$fef38ba78dbe85a6 = {
    text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $f9006b515271a00f$var$i18n.externalGroupTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $f9006b515271a00f$var$i18n.externalGroupLozengeText)),
    appearance: 'new',
    isBold: false
};
const $f9006b515271a00f$export$e899659b70340bcf = ()=>{
    const { text: text, appearance: appearance, isBold: isBold } = $f9006b515271a00f$export$fef38ba78dbe85a6;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $aIk0I.default), {
        appearance: appearance,
        isBold: isBold
    }, text);
};

});

parcelRegister("6RGMW", function(module, exports) {

$parcel$export(module.exports, "UserAndGroupSearchQuery", () => $88fbd0e78227b736$export$9eed0d08b5194ae7);

var $d2LG0 = parcelRequire("d2LG0");
const $88fbd0e78227b736$export$9eed0d08b5194ae7 = (0, $d2LG0.default)`query UserAndGroupSearchQuery($searchTerm:String!$maxResults:Int=50$withGroups:Boolean=true$withUsers:Boolean=true$sitePermissionTypeFilter:SitePermissionTypeFilter=NONE){userGroupSearch(query:$searchTerm maxResults:$maxResults sitePermissionTypeFilter:$sitePermissionTypeFilter){users@include(if:$withUsers){type displayName permissionType profilePicture{path}...on User{accountId}...on KnownUser{accountId}}groups@include(if:$withGroups){id name permissionType}}}`;

});



parcelRegister("62BfR", function(module, exports) {

$parcel$export(module.exports, "replaceAtlTokenPlaceholder", () => $d97d2e8640b15cc8$export$87286345b169ae5e);
function $d97d2e8640b15cc8$export$87286345b169ae5e(data) {
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const atlToken = document.querySelector('meta[name="ajs-atl-token"]')?.content;
    if (!atlToken || !data || !data.webItemSections) return data;
    return {
        ...data,
        webItemSections: data.webItemSections.map((section)=>{
            if (section) return {
                ...section,
                items: section?.items.map((sectionItem)=>{
                    if (sectionItem) return {
                        ...sectionItem,
                        url: sectionItem.url?.replace('{atlTokenPlaceholderWillBeReplacedInFrontend}', atlToken) ?? sectionItem.url,
                        urlWithoutContextPath: sectionItem.urlWithoutContextPath?.replace('{atlTokenPlaceholderWillBeReplacedInFrontend}', atlToken) ?? sectionItem.urlWithoutContextPath
                    };
                    else return null;
                })
            };
            else return null;
        })
    };
}

});

parcelRegister("bVAxT", function(module, exports) {

$parcel$export(module.exports, "RestrictionsDialogStateContainer", () => $20c3e8ab10e63e24$export$f91385b453474810);
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $ipPpS = parcelRequire("ipPpS");
class $20c3e8ab10e63e24$export$f91385b453474810 extends (0, $ipPpS.Container) {
    getContentId() {
        return this.state.contentId;
    }
    getIsOpen() {
        return this.state.isOpen;
    }
    getTriggeredFrom() {
        return this.state.triggeredFrom;
    }
    getHideRestrictionsButtonSpinner() {
        return this.state.hideRestrictionsButtonSpinner;
    }
    setIsOpen(isOpen, triggeredFrom = null, callback) {
        return this.setState({
            isOpen: isOpen,
            triggeredFrom: triggeredFrom
        }, ()=>{
            if (callback) // using setTimeout here to let dialog transitions finish in case we want to interact with the UI. needed to trigger the share button.
            setTimeout(callback, 0);
        });
    }
    setContentId(contentId) {
        return this.setState({
            contentId: contentId
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            isOpen: false,
            triggeredFrom: null,
            hideRestrictionsButtonSpinner: false,
            contentId: ''
        };
        this.initState = ()=>{
            return this.setState({
                contentId: '',
                isOpen: false,
                triggeredFrom: null,
                hideRestrictionsButtonSpinner: false
            });
        };
        this.setHideRestrictionsButtonSpinner = ()=>{
            return this.setState({
                hideRestrictionsButtonSpinner: true
            });
        };
    }
}

});

parcelRegister("tvI67", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::552918135e976d59647ada829319b3a6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $058b4e8b1f67a9a7$var$_react = $058b4e8b1f67a9a7$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $058b4e8b1f67a9a7$var$_baseNew = $058b4e8b1f67a9a7$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $058b4e8b1f67a9a7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Apps".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for adding or viewing apps.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $058b4e8b1f67a9a7$var$AppsIcon = (props)=>/*#__PURE__*/ $058b4e8b1f67a9a7$var$_react.default.createElement($058b4e8b1f67a9a7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM9 3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM1 11a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5zm8.25.75V9h1.5v2.25H15v1.5h-2.25V15h-1.5v-2.25H9v-1.5z" clip-rule="evenodd"/>`
    }, props));
$058b4e8b1f67a9a7$var$AppsIcon.displayName = 'AppsIcon';
var $058b4e8b1f67a9a7$var$_default = module.exports.default = $058b4e8b1f67a9a7$var$AppsIcon;

});

parcelRegister("h1ewt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::25e57ba6be3183cfa1e359a1a5374e32>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c63dcb99536cc850$var$_react = $c63dcb99536cc850$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $c63dcb99536cc850$var$_baseNew = $c63dcb99536cc850$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $c63dcb99536cc850$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockUnlocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: unlocked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c63dcb99536cc850$var$LockUnlockedIcon = (props)=>/*#__PURE__*/ $c63dcb99536cc850$var$_react.default.createElement($c63dcb99536cc850$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3H12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2V4a4 4 0 1 1 8 0h-1.5A2.5 2.5 0 0 0 8 1.5m-4 7a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$c63dcb99536cc850$var$LockUnlockedIcon.displayName = 'LockUnlockedIcon';
var $c63dcb99536cc850$var$_default = module.exports.default = $c63dcb99536cc850$var$LockUnlockedIcon;

});

parcelRegister("6UqI3", function(module, exports) {

$parcel$export(module.exports, "getSpaceType", () => $a3c7cd489159fe33$export$28eddf802cd184f7);
const $a3c7cd489159fe33$export$28eddf802cd184f7 = (spaceKey)=>{
    return spaceKey?.[0] === '~' ? 'personal' : 'global';
};

});

parcelRegister("3P1RK", function(module, exports) {

$parcel$export(module.exports, "SpacePermissionsTabKey", () => $4a56ff9e2636e665$export$ad59ff7dc414850a);
$parcel$export(module.exports, "SPACE_PERMISSION_TAB_KEY_PRINCIPAL_MAP", () => $4a56ff9e2636e665$export$d4f1d7ffc41e2d29);

var $fHoxN = parcelRequire("fHoxN");
var $4a56ff9e2636e665$export$ad59ff7dc414850a = /*#__PURE__*/ function(SpacePermissionsTabKey) {
    SpacePermissionsTabKey["Groups"] = "groups";
    SpacePermissionsTabKey["Users"] = "users";
    SpacePermissionsTabKey["Guests"] = "guests";
    SpacePermissionsTabKey["AnonymousAccess"] = "anonymous";
    SpacePermissionsTabKey["PublicLinks"] = "public-links";
    SpacePermissionsTabKey["Analytics"] = "analytics";
    return SpacePermissionsTabKey;
}({});
const $4a56ff9e2636e665$export$d4f1d7ffc41e2d29 = {
    ["groups"]: (0, $fHoxN.PermissionDisplayType).GROUP,
    ["users"]: (0, $fHoxN.PermissionDisplayType).LICENSED_USER,
    ["guests"]: (0, $fHoxN.PermissionDisplayType).GUEST_USER,
    ["anonymous"]: (0, $fHoxN.PermissionDisplayType).ANONYMOUS
};

});
parcelRegister("fHoxN", function(module, exports) {

$parcel$export(module.exports, "PermissionDisplayType", () => $8a20bb30841ead37$export$f1a726cdbae0d72a);
$parcel$export(module.exports, "SpacePermissionType", () => $8a20bb30841ead37$export$a99f5dae9c149910);
/**
 * @generated SignedSource<<ea3843edd17bea243ec9dc06a44ce09f>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $8a20bb30841ead37$export$f1a726cdbae0d72a = /*#__PURE__*/ function(PermissionDisplayType) {
    PermissionDisplayType["ANONYMOUS"] = "ANONYMOUS";
    PermissionDisplayType["GROUP"] = "GROUP";
    PermissionDisplayType["GUEST_USER"] = "GUEST_USER";
    PermissionDisplayType["LICENSED_USER"] = "LICENSED_USER";
    return PermissionDisplayType;
}({});
var $8a20bb30841ead37$export$a99f5dae9c149910 = /*#__PURE__*/ function(SpacePermissionType) {
    SpacePermissionType["ADMINISTER_SPACE"] = "ADMINISTER_SPACE";
    SpacePermissionType["ARCHIVE_PAGE"] = "ARCHIVE_PAGE";
    SpacePermissionType["ARCHIVE_SPACE"] = "ARCHIVE_SPACE";
    SpacePermissionType["COMMENT"] = "COMMENT";
    SpacePermissionType["CREATE_ATTACHMENT"] = "CREATE_ATTACHMENT";
    SpacePermissionType["CREATE_BLOG"] = "CREATE_BLOG";
    SpacePermissionType["CREATE_EDIT_PAGE"] = "CREATE_EDIT_PAGE";
    SpacePermissionType["DELETE_SPACE"] = "DELETE_SPACE";
    SpacePermissionType["EDIT_BLOG"] = "EDIT_BLOG";
    SpacePermissionType["EDIT_NATIVE_CONTENT"] = "EDIT_NATIVE_CONTENT";
    SpacePermissionType["EXPORT_CONTENT"] = "EXPORT_CONTENT";
    SpacePermissionType["EXPORT_PAGE"] = "EXPORT_PAGE";
    SpacePermissionType["EXPORT_SPACE"] = "EXPORT_SPACE";
    SpacePermissionType["MANAGE_GUEST_USERS"] = "MANAGE_GUEST_USERS";
    SpacePermissionType["MANAGE_NONLICENSED_USERS"] = "MANAGE_NONLICENSED_USERS";
    SpacePermissionType["MANAGE_PUBLIC_LINKS"] = "MANAGE_PUBLIC_LINKS";
    SpacePermissionType["MANAGE_USERS"] = "MANAGE_USERS";
    SpacePermissionType["REMOVE_ATTACHMENT"] = "REMOVE_ATTACHMENT";
    SpacePermissionType["REMOVE_BLOG"] = "REMOVE_BLOG";
    SpacePermissionType["REMOVE_COMMENT"] = "REMOVE_COMMENT";
    SpacePermissionType["REMOVE_MAIL"] = "REMOVE_MAIL";
    SpacePermissionType["REMOVE_OWN_CONTENT"] = "REMOVE_OWN_CONTENT";
    SpacePermissionType["REMOVE_PAGE"] = "REMOVE_PAGE";
    SpacePermissionType["SET_PAGE_PERMISSIONS"] = "SET_PAGE_PERMISSIONS";
    SpacePermissionType["VIEW_SPACE"] = "VIEW_SPACE";
    return SpacePermissionType;
}({});

});


parcelRegister("hfPJk", function(module, exports) {

$parcel$export(module.exports, "useUnifiedShareDialogEligible", () => $4c837cd68f9ce4c0$export$ec1a39480eeb12ae);

var $d9tcB = parcelRequire("d9tcB");
var $bQm3c = parcelRequire("bQm3c");

var $euL71 = parcelRequire("euL71");

var $6mKj3 = parcelRequire("6mKj3");
const $4c837cd68f9ce4c0$export$ec1a39480eeb12ae = (skipExposure = false)=>{
    const { edition: edition, isLoggedIn: isLoggedIn, accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isLicensed = [
        (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS,
        (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS
    ].includes(accessStatus);
    const isStandard = [
        (0, $euL71.ConfluenceEdition).STANDARD
    ].includes(edition);
    const isEligible = isLoggedIn && isLicensed && isStandard;
    return {
        isUSDExperimentEnabled: isEligible ? skipExposure ? (0, $6mKj3.expValEqualsNoExposure)('unified_share_dialog_usd_experiment', 'cohort', 'test') : (0, $6mKj3.expValEquals)('unified_share_dialog_usd_experiment', 'cohort', 'test') : false
    };
};

});

parcelRegister("4vC63", function(module, exports) {

$parcel$export(module.exports, "ForgeKeyboardShortcutVisualizer", () => $c1fece3650e281b8$export$b804abdac3f5f117);
$parcel$export(module.exports, "ForgeKeyboardShortcut", () => $c1fece3650e281b8$export$4e51bfd8ba3e71ef);

var $gwFzn = parcelRequire("gwFzn");

var $3gadb = parcelRequire("3gadb");

var $ljm2R = parcelRequire("ljm2R");
const $c1fece3650e281b8$var$getAccelerator = (module)=>module?.properties?.keyboardShortcut?.accelerator ?? '';
const $c1fece3650e281b8$export$b804abdac3f5f117 = ({ module: module, tooltip: tooltip = '', children: children })=>{
    const accelerator = $c1fece3650e281b8$var$getAccelerator(module);
    if (accelerator && !(0, $ljm2R.RESERVED_SHORTCUTS).includes(accelerator)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
        tag: "span",
        testId: `forge-keyboard-shortcut-visualizer-${accelerator}`,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ljm2R.ShortcutVisualizer), {
            shortcut: accelerator,
            contentBefore: tooltip
        })
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, children);
};
const $c1fece3650e281b8$export$4e51bfd8ba3e71ef = ({ module: module, action: action })=>{
    const accelerator = $c1fece3650e281b8$var$getAccelerator(module);
    if (accelerator && action && !(0, $ljm2R.RESERVED_SHORTCUTS).includes(accelerator)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", {
        "data-testid": `forge-keyboard-shortcut-${accelerator}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ljm2R.GeneralShortcutListener), {
        accelerator: accelerator,
        listener: action,
        shortcutType: (0, $ljm2R.ShortcutType).Forge
    }));
    return null;
};

});

parcelRegister("7QUD1", function(module, exports) {

$parcel$export(module.exports, "ByLineForgeApp", () => $02976f123c8f8e25$export$d2159b9f3f077903);
$parcel$export(module.exports, "ContentActionForgeApp", () => $02976f123c8f8e25$export$f900958ce7c4410f);
$parcel$export(module.exports, "ContextMenuForgeApp", () => $02976f123c8f8e25$export$79ed117743c6c2cf);
$parcel$export(module.exports, "GlobalPageForgeApp", () => $02976f123c8f8e25$export$83db8797814193a8);
$parcel$export(module.exports, "GlobalSettingsForgeApp", () => $02976f123c8f8e25$export$74528162c4c3828b);
$parcel$export(module.exports, "HomepageFeedForgeApp", () => $02976f123c8f8e25$export$c8291e2d6d6adbf2);
$parcel$export(module.exports, "SpaceSettingsForgeApp", () => $02976f123c8f8e25$export$e8858129e933f7e8);
$parcel$export(module.exports, "CustomContentForgeApp", () => $02976f123c8f8e25$export$578d0cbdb0ffa72e);
$parcel$export(module.exports, "BackgroundScriptForgeApp", () => $02976f123c8f8e25$export$40d4b5cfa6c18ea7);
$parcel$export(module.exports, "PageBannerForgeApp", () => $02976f123c8f8e25$export$c76787f94e0b1609);

var $jmjWc = parcelRequire("jmjWc");

const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("hOG59"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("bIxg8"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("8utjK"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("9ftiB"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("7ecbw"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("bjy2C"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("18Vj3"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("1UQ8l"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("8p5Of"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("at1dq"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("lisn1"))).PageBannerForgeApp
});

});
parcelRegister("hOG59", function(module, exports) {

let $cf87bfcc10f34231$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $cf87bfcc10f34231$var$load("7Q0UC"),
    $cf87bfcc10f34231$var$load("hf7yW"),
    $cf87bfcc10f34231$var$load("lU1wr"),
    $cf87bfcc10f34231$var$load("29wqP"),
    $cf87bfcc10f34231$var$load("lnKog"),
    $cf87bfcc10f34231$var$load("2aE9V"),
    $cf87bfcc10f34231$var$load("iQ0Jm"),
    $cf87bfcc10f34231$var$load("9L8th"),
    $cf87bfcc10f34231$var$load("daCl8"),
    $cf87bfcc10f34231$var$load("kSCMk"),
    $cf87bfcc10f34231$var$load("gQSWJ"),
    $cf87bfcc10f34231$var$load("1c4TZ"),
    $cf87bfcc10f34231$var$load("cplyI"),
    $cf87bfcc10f34231$var$load("5HsIb"),
    $cf87bfcc10f34231$var$load("7VwsU"),
    $cf87bfcc10f34231$var$load("fsZ6i"),
    $cf87bfcc10f34231$var$load("3689E"),
    $cf87bfcc10f34231$var$load("g1XVY"),
    $cf87bfcc10f34231$var$load("keSaw"),
    $cf87bfcc10f34231$var$load("9fG7I"),
    $cf87bfcc10f34231$var$load("gwAWX"),
    $cf87bfcc10f34231$var$load("h4Nf7"),
    $cf87bfcc10f34231$var$load("6ZgMI"),
    $cf87bfcc10f34231$var$load("9FBaW"),
    $cf87bfcc10f34231$var$load("6StWh"),
    $cf87bfcc10f34231$var$load("g9CVe"),
    $cf87bfcc10f34231$var$load("8wMGm"),
    $cf87bfcc10f34231$var$load("4aLlP"),
    $cf87bfcc10f34231$var$load("6gqpV"),
    $cf87bfcc10f34231$var$load("aZinD"),
    $cf87bfcc10f34231$var$load("4Pn6Z"),
    $cf87bfcc10f34231$var$load("6qah4"),
    $cf87bfcc10f34231$var$load("c6MKV"),
    $cf87bfcc10f34231$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("bIxg8", function(module, exports) {

let $887d9a5bd97a6783$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $887d9a5bd97a6783$var$load("7Q0UC"),
    $887d9a5bd97a6783$var$load("hf7yW"),
    $887d9a5bd97a6783$var$load("lU1wr"),
    $887d9a5bd97a6783$var$load("29wqP"),
    $887d9a5bd97a6783$var$load("lnKog"),
    $887d9a5bd97a6783$var$load("2aE9V"),
    $887d9a5bd97a6783$var$load("iQ0Jm"),
    $887d9a5bd97a6783$var$load("9L8th"),
    $887d9a5bd97a6783$var$load("daCl8"),
    $887d9a5bd97a6783$var$load("kSCMk"),
    $887d9a5bd97a6783$var$load("gQSWJ"),
    $887d9a5bd97a6783$var$load("1c4TZ"),
    $887d9a5bd97a6783$var$load("cplyI"),
    $887d9a5bd97a6783$var$load("5HsIb"),
    $887d9a5bd97a6783$var$load("7VwsU"),
    $887d9a5bd97a6783$var$load("fsZ6i"),
    $887d9a5bd97a6783$var$load("3689E"),
    $887d9a5bd97a6783$var$load("g1XVY"),
    $887d9a5bd97a6783$var$load("keSaw"),
    $887d9a5bd97a6783$var$load("9fG7I"),
    $887d9a5bd97a6783$var$load("gwAWX"),
    $887d9a5bd97a6783$var$load("h4Nf7"),
    $887d9a5bd97a6783$var$load("6ZgMI"),
    $887d9a5bd97a6783$var$load("9FBaW"),
    $887d9a5bd97a6783$var$load("6StWh"),
    $887d9a5bd97a6783$var$load("g9CVe"),
    $887d9a5bd97a6783$var$load("8wMGm"),
    $887d9a5bd97a6783$var$load("4aLlP"),
    $887d9a5bd97a6783$var$load("6gqpV"),
    $887d9a5bd97a6783$var$load("aZinD"),
    $887d9a5bd97a6783$var$load("4Pn6Z"),
    $887d9a5bd97a6783$var$load("6qah4"),
    $887d9a5bd97a6783$var$load("c6MKV"),
    $887d9a5bd97a6783$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("8utjK", function(module, exports) {

let $62e7ddf1c02da5d8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $62e7ddf1c02da5d8$var$load("7Q0UC"),
    $62e7ddf1c02da5d8$var$load("hf7yW"),
    $62e7ddf1c02da5d8$var$load("lU1wr"),
    $62e7ddf1c02da5d8$var$load("29wqP"),
    $62e7ddf1c02da5d8$var$load("lnKog"),
    $62e7ddf1c02da5d8$var$load("2aE9V"),
    $62e7ddf1c02da5d8$var$load("iQ0Jm"),
    $62e7ddf1c02da5d8$var$load("9L8th"),
    $62e7ddf1c02da5d8$var$load("daCl8"),
    $62e7ddf1c02da5d8$var$load("kSCMk"),
    $62e7ddf1c02da5d8$var$load("gQSWJ"),
    $62e7ddf1c02da5d8$var$load("1c4TZ"),
    $62e7ddf1c02da5d8$var$load("cplyI"),
    $62e7ddf1c02da5d8$var$load("5HsIb"),
    $62e7ddf1c02da5d8$var$load("7VwsU"),
    $62e7ddf1c02da5d8$var$load("fsZ6i"),
    $62e7ddf1c02da5d8$var$load("3689E"),
    $62e7ddf1c02da5d8$var$load("g1XVY"),
    $62e7ddf1c02da5d8$var$load("keSaw"),
    $62e7ddf1c02da5d8$var$load("9fG7I"),
    $62e7ddf1c02da5d8$var$load("gwAWX"),
    $62e7ddf1c02da5d8$var$load("h4Nf7"),
    $62e7ddf1c02da5d8$var$load("6ZgMI"),
    $62e7ddf1c02da5d8$var$load("9FBaW"),
    $62e7ddf1c02da5d8$var$load("6StWh"),
    $62e7ddf1c02da5d8$var$load("g9CVe"),
    $62e7ddf1c02da5d8$var$load("8wMGm"),
    $62e7ddf1c02da5d8$var$load("4aLlP"),
    $62e7ddf1c02da5d8$var$load("6gqpV"),
    $62e7ddf1c02da5d8$var$load("aZinD"),
    $62e7ddf1c02da5d8$var$load("4Pn6Z"),
    $62e7ddf1c02da5d8$var$load("6qah4"),
    $62e7ddf1c02da5d8$var$load("c6MKV"),
    $62e7ddf1c02da5d8$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("9ftiB", function(module, exports) {

let $6bbc3df1cf0cf1af$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $6bbc3df1cf0cf1af$var$load("9L8th"),
    $6bbc3df1cf0cf1af$var$load("kSCMk"),
    $6bbc3df1cf0cf1af$var$load("5HsIb"),
    $6bbc3df1cf0cf1af$var$load("7VwsU"),
    $6bbc3df1cf0cf1af$var$load("fsZ6i"),
    $6bbc3df1cf0cf1af$var$load("3689E"),
    $6bbc3df1cf0cf1af$var$load("g1XVY"),
    $6bbc3df1cf0cf1af$var$load("keSaw"),
    $6bbc3df1cf0cf1af$var$load("9fG7I"),
    $6bbc3df1cf0cf1af$var$load("gwAWX"),
    $6bbc3df1cf0cf1af$var$load("h4Nf7"),
    $6bbc3df1cf0cf1af$var$load("6ZgMI"),
    $6bbc3df1cf0cf1af$var$load("9FBaW"),
    $6bbc3df1cf0cf1af$var$load("6StWh"),
    $6bbc3df1cf0cf1af$var$load("g9CVe"),
    $6bbc3df1cf0cf1af$var$load("6qah4"),
    $6bbc3df1cf0cf1af$var$load("8wMGm"),
    $6bbc3df1cf0cf1af$var$load("6gqpV"),
    $6bbc3df1cf0cf1af$var$load("aZinD"),
    $6bbc3df1cf0cf1af$var$load("4Pn6Z"),
    $6bbc3df1cf0cf1af$var$load("c6MKV"),
    $6bbc3df1cf0cf1af$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("7ecbw", function(module, exports) {

let $54334ad9c3f1c2bc$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $54334ad9c3f1c2bc$var$load("9L8th"),
    $54334ad9c3f1c2bc$var$load("kSCMk"),
    $54334ad9c3f1c2bc$var$load("5HsIb"),
    $54334ad9c3f1c2bc$var$load("7VwsU"),
    $54334ad9c3f1c2bc$var$load("fsZ6i"),
    $54334ad9c3f1c2bc$var$load("3689E"),
    $54334ad9c3f1c2bc$var$load("g1XVY"),
    $54334ad9c3f1c2bc$var$load("keSaw"),
    $54334ad9c3f1c2bc$var$load("9fG7I"),
    $54334ad9c3f1c2bc$var$load("gwAWX"),
    $54334ad9c3f1c2bc$var$load("h4Nf7"),
    $54334ad9c3f1c2bc$var$load("6ZgMI"),
    $54334ad9c3f1c2bc$var$load("9FBaW"),
    $54334ad9c3f1c2bc$var$load("6StWh"),
    $54334ad9c3f1c2bc$var$load("g9CVe"),
    $54334ad9c3f1c2bc$var$load("6qah4"),
    $54334ad9c3f1c2bc$var$load("8wMGm"),
    $54334ad9c3f1c2bc$var$load("6gqpV"),
    $54334ad9c3f1c2bc$var$load("aZinD"),
    $54334ad9c3f1c2bc$var$load("4Pn6Z"),
    $54334ad9c3f1c2bc$var$load("c6MKV"),
    $54334ad9c3f1c2bc$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("bjy2C", function(module, exports) {

let $83cbdfeef08285ec$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $83cbdfeef08285ec$var$load("lU1wr"),
    $83cbdfeef08285ec$var$load("29wqP"),
    $83cbdfeef08285ec$var$load("lnKog"),
    $83cbdfeef08285ec$var$load("9L8th"),
    $83cbdfeef08285ec$var$load("kSCMk"),
    $83cbdfeef08285ec$var$load("5HsIb"),
    $83cbdfeef08285ec$var$load("7VwsU"),
    $83cbdfeef08285ec$var$load("fsZ6i"),
    $83cbdfeef08285ec$var$load("3689E"),
    $83cbdfeef08285ec$var$load("g1XVY"),
    $83cbdfeef08285ec$var$load("keSaw"),
    $83cbdfeef08285ec$var$load("9fG7I"),
    $83cbdfeef08285ec$var$load("gwAWX"),
    $83cbdfeef08285ec$var$load("h4Nf7"),
    $83cbdfeef08285ec$var$load("6ZgMI"),
    $83cbdfeef08285ec$var$load("9FBaW"),
    $83cbdfeef08285ec$var$load("6StWh"),
    $83cbdfeef08285ec$var$load("g9CVe"),
    $83cbdfeef08285ec$var$load("6qah4"),
    $83cbdfeef08285ec$var$load("8wMGm"),
    $83cbdfeef08285ec$var$load("6gqpV"),
    $83cbdfeef08285ec$var$load("aZinD"),
    $83cbdfeef08285ec$var$load("4Pn6Z"),
    $83cbdfeef08285ec$var$load("c6MKV"),
    $83cbdfeef08285ec$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("18Vj3", function(module, exports) {

let $0d52fdaa7d612384$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $0d52fdaa7d612384$var$load("7Q0UC"),
    $0d52fdaa7d612384$var$load("lU1wr"),
    $0d52fdaa7d612384$var$load("29wqP"),
    $0d52fdaa7d612384$var$load("lnKog"),
    $0d52fdaa7d612384$var$load("9L8th"),
    $0d52fdaa7d612384$var$load("kSCMk"),
    $0d52fdaa7d612384$var$load("1c4TZ"),
    $0d52fdaa7d612384$var$load("cplyI"),
    $0d52fdaa7d612384$var$load("5HsIb"),
    $0d52fdaa7d612384$var$load("7VwsU"),
    $0d52fdaa7d612384$var$load("fsZ6i"),
    $0d52fdaa7d612384$var$load("3689E"),
    $0d52fdaa7d612384$var$load("g1XVY"),
    $0d52fdaa7d612384$var$load("keSaw"),
    $0d52fdaa7d612384$var$load("9fG7I"),
    $0d52fdaa7d612384$var$load("gwAWX"),
    $0d52fdaa7d612384$var$load("h4Nf7"),
    $0d52fdaa7d612384$var$load("6ZgMI"),
    $0d52fdaa7d612384$var$load("dTsOE"),
    $0d52fdaa7d612384$var$load("9FBaW"),
    $0d52fdaa7d612384$var$load("6StWh"),
    $0d52fdaa7d612384$var$load("g9CVe"),
    $0d52fdaa7d612384$var$load("6qah4"),
    $0d52fdaa7d612384$var$load("8wMGm"),
    $0d52fdaa7d612384$var$load("4aLlP"),
    $0d52fdaa7d612384$var$load("6gqpV"),
    $0d52fdaa7d612384$var$load("aZinD"),
    $0d52fdaa7d612384$var$load("4Pn6Z"),
    $0d52fdaa7d612384$var$load("c6MKV"),
    $0d52fdaa7d612384$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("1UQ8l", function(module, exports) {

let $1653760b2a7e881a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $1653760b2a7e881a$var$load("7Q0UC"),
    $1653760b2a7e881a$var$load("lU1wr"),
    $1653760b2a7e881a$var$load("29wqP"),
    $1653760b2a7e881a$var$load("lnKog"),
    $1653760b2a7e881a$var$load("9L8th"),
    $1653760b2a7e881a$var$load("kSCMk"),
    $1653760b2a7e881a$var$load("1c4TZ"),
    $1653760b2a7e881a$var$load("cplyI"),
    $1653760b2a7e881a$var$load("5HsIb"),
    $1653760b2a7e881a$var$load("7VwsU"),
    $1653760b2a7e881a$var$load("fsZ6i"),
    $1653760b2a7e881a$var$load("3689E"),
    $1653760b2a7e881a$var$load("g1XVY"),
    $1653760b2a7e881a$var$load("keSaw"),
    $1653760b2a7e881a$var$load("9fG7I"),
    $1653760b2a7e881a$var$load("gwAWX"),
    $1653760b2a7e881a$var$load("h4Nf7"),
    $1653760b2a7e881a$var$load("6ZgMI"),
    $1653760b2a7e881a$var$load("dTsOE"),
    $1653760b2a7e881a$var$load("9FBaW"),
    $1653760b2a7e881a$var$load("6StWh"),
    $1653760b2a7e881a$var$load("g9CVe"),
    $1653760b2a7e881a$var$load("6qah4"),
    $1653760b2a7e881a$var$load("8wMGm"),
    $1653760b2a7e881a$var$load("4aLlP"),
    $1653760b2a7e881a$var$load("6gqpV"),
    $1653760b2a7e881a$var$load("aZinD"),
    $1653760b2a7e881a$var$load("4Pn6Z"),
    $1653760b2a7e881a$var$load("c6MKV"),
    $1653760b2a7e881a$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("8p5Of", function(module, exports) {

let $61e52a2a5ea3711c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $61e52a2a5ea3711c$var$load("9L8th"),
    $61e52a2a5ea3711c$var$load("kSCMk"),
    $61e52a2a5ea3711c$var$load("5HsIb"),
    $61e52a2a5ea3711c$var$load("7VwsU"),
    $61e52a2a5ea3711c$var$load("fsZ6i"),
    $61e52a2a5ea3711c$var$load("3689E"),
    $61e52a2a5ea3711c$var$load("g1XVY"),
    $61e52a2a5ea3711c$var$load("keSaw"),
    $61e52a2a5ea3711c$var$load("9fG7I"),
    $61e52a2a5ea3711c$var$load("gwAWX"),
    $61e52a2a5ea3711c$var$load("h4Nf7"),
    $61e52a2a5ea3711c$var$load("6ZgMI"),
    $61e52a2a5ea3711c$var$load("9FBaW"),
    $61e52a2a5ea3711c$var$load("6StWh"),
    $61e52a2a5ea3711c$var$load("g9CVe"),
    $61e52a2a5ea3711c$var$load("6qah4"),
    $61e52a2a5ea3711c$var$load("8wMGm"),
    $61e52a2a5ea3711c$var$load("6gqpV"),
    $61e52a2a5ea3711c$var$load("aZinD"),
    $61e52a2a5ea3711c$var$load("4Pn6Z"),
    $61e52a2a5ea3711c$var$load("c6MKV"),
    $61e52a2a5ea3711c$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("at1dq", function(module, exports) {

let $79ed8e349805c425$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $79ed8e349805c425$var$load("lU1wr"),
    $79ed8e349805c425$var$load("29wqP"),
    $79ed8e349805c425$var$load("lnKog"),
    $79ed8e349805c425$var$load("9L8th"),
    $79ed8e349805c425$var$load("kSCMk"),
    $79ed8e349805c425$var$load("5HsIb"),
    $79ed8e349805c425$var$load("7VwsU"),
    $79ed8e349805c425$var$load("fsZ6i"),
    $79ed8e349805c425$var$load("3689E"),
    $79ed8e349805c425$var$load("g1XVY"),
    $79ed8e349805c425$var$load("keSaw"),
    $79ed8e349805c425$var$load("9fG7I"),
    $79ed8e349805c425$var$load("gwAWX"),
    $79ed8e349805c425$var$load("h4Nf7"),
    $79ed8e349805c425$var$load("6ZgMI"),
    $79ed8e349805c425$var$load("9FBaW"),
    $79ed8e349805c425$var$load("6StWh"),
    $79ed8e349805c425$var$load("g9CVe"),
    $79ed8e349805c425$var$load("6qah4"),
    $79ed8e349805c425$var$load("8wMGm"),
    $79ed8e349805c425$var$load("6gqpV"),
    $79ed8e349805c425$var$load("aZinD"),
    $79ed8e349805c425$var$load("4Pn6Z"),
    $79ed8e349805c425$var$load("c6MKV"),
    $79ed8e349805c425$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("lisn1", function(module, exports) {

let $f8114927775d26ea$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $f8114927775d26ea$var$load("lU1wr"),
    $f8114927775d26ea$var$load("29wqP"),
    $f8114927775d26ea$var$load("lnKog"),
    $f8114927775d26ea$var$load("9L8th"),
    $f8114927775d26ea$var$load("kSCMk"),
    $f8114927775d26ea$var$load("5HsIb"),
    $f8114927775d26ea$var$load("7VwsU"),
    $f8114927775d26ea$var$load("fsZ6i"),
    $f8114927775d26ea$var$load("3689E"),
    $f8114927775d26ea$var$load("g1XVY"),
    $f8114927775d26ea$var$load("keSaw"),
    $f8114927775d26ea$var$load("9fG7I"),
    $f8114927775d26ea$var$load("gwAWX"),
    $f8114927775d26ea$var$load("h4Nf7"),
    $f8114927775d26ea$var$load("6ZgMI"),
    $f8114927775d26ea$var$load("9FBaW"),
    $f8114927775d26ea$var$load("6StWh"),
    $f8114927775d26ea$var$load("g9CVe"),
    $f8114927775d26ea$var$load("6qah4"),
    $f8114927775d26ea$var$load("8wMGm"),
    $f8114927775d26ea$var$load("6gqpV"),
    $f8114927775d26ea$var$load("aZinD"),
    $f8114927775d26ea$var$load("4Pn6Z"),
    $f8114927775d26ea$var$load("c6MKV"),
    $f8114927775d26ea$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});


parcelRegister("grspz", function(module, exports) {

$parcel$export(module.exports, "getLocalId", () => $cdcead6f01277136$export$957229695d10ea4a);
const $cdcead6f01277136$export$957229695d10ea4a = (extensionId)=>{
    return extensionId.replace(/[^a-zA-Z0-9-]/g, '-');
};

});

parcelRegister("8a9Dm", function(module, exports) {

$parcel$export(module.exports, "getAppId", () => $2cc1b73219e08564$export$fb2283f4a44fb53);
$parcel$export(module.exports, "getModuleKey", () => $2cc1b73219e08564$export$b17b21a48c0a3273);
$parcel$export(module.exports, "getCustomContentType", () => $2cc1b73219e08564$export$9eb690901638fb96);
const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
const $2cc1b73219e08564$export$d3ac53161a36a310 = (forgeData)=>{
    const extensionContext = forgeData?.extensionContexts?.[0];
    if (!extensionContext) return [];
    if (extensionContext.hasOwnProperty('extensions')) return extensionContext.extensions;
    if (extensionContext.hasOwnProperty('extensionsByType')) return extensionContext.extensionsByType;
    return [];
};

});

parcelRegister("6ld6a", function(module, exports) {

$parcel$export(module.exports, "useWebItemLocation", () => $f64809aa9d8f3ca2$export$13a30d244c53e90d);

var $diswb = parcelRequire("diswb");

var $jV49M = parcelRequire("jV49M");

var $jIQq0 = parcelRequire("jIQq0");

var $fjiOd = parcelRequire("fjiOd");

var $62BfR = parcelRequire("62BfR");
const $f64809aa9d8f3ca2$export$13a30d244c53e90d = ({ location: location, contentId: contentId = null, spaceKey: spaceKey = null, version: version = null, fetchPolicy: fetchPolicy = 'cache-and-network', allowedWebItems: allowedWebItems, notAllowedWebItems: notAllowedWebItems, skipQuery: skipQuery })=>{
    const { data: data, loading: loading, error: error } = (0, $diswb.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $fjiOd.WebItemLocationQuery), {
        fetchPolicy: fetchPolicy,
        variables: {
            // GraphQL doesn't cache single location strings properly when passed to locations
            // unless we're using multiple locations we should be using the location variable
            location: Array.isArray(location) ? null : location,
            locations: Array.isArray(location) ? location : [],
            contentId: contentId,
            spaceKey: spaceKey,
            version: version
        },
        skip: skipQuery
    });
    if (!data) return {
        loading: loading,
        error: error,
        webItems: [],
        webSections: []
    };
    // replace any instances of {atlTokenPlaceholderWillBeReplacedInFrontend}
    // with the atlToken in all section items
    const webItems = $f64809aa9d8f3ca2$var$getWebItems((0, $62BfR.replaceAtlTokenPlaceholder)(data)?.webItemSections, {
        allowedWebItems: allowedWebItems,
        notAllowedWebItems: notAllowedWebItems
    });
    const webSections = (0, (/*@__PURE__*/$parcel$interopDefault($jIQq0)))(webItems.map((webItem)=>webItem.section));
    webItems.sort($f64809aa9d8f3ca2$var$sortWebItems);
    return {
        // Since the default fetchPolicy is cache-and-network
        // loading field will be true, false, true (background refetch), false
        // Query is refreshing when data not empty but loading is true
        // Padding loading false to avoid reverting back to the empty state or loading skeleton.
        // This aligns with confluence/next/packages/web-item-location/src/WebItemLocation.tsx
        loading: false,
        error: error,
        webItems: webItems,
        webSections: webSections
    };
};
const $f64809aa9d8f3ca2$var$getWebItems = (webItemSections, webItemFilterOptions)=>{
    const webItems = webItemSections.flatMap((section)=>{
        return section.items.filter($f64809aa9d8f3ca2$var$filterWebItem(webItemFilterOptions)).map($f64809aa9d8f3ca2$var$transformWebItem(section));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($jV49M)))(webItems, 'completeKey');
};
const $f64809aa9d8f3ca2$var$filterWebItem = ({ allowedWebItems: allowedWebItems, notAllowedWebItems: notAllowedWebItems })=>(item)=>{
        if (item === null || item.completeKey === null) return false;
        const isAllowed = !allowedWebItems || allowedWebItems.includes(item.completeKey);
        const isDisallowed = notAllowedWebItems?.includes(item.completeKey);
        return isAllowed && !isDisallowed;
    };
const $f64809aa9d8f3ca2$var$transformWebItem = (section)=>(rawItem)=>({
            ...rawItem,
            params: $f64809aa9d8f3ca2$var$getParamsObject(rawItem),
            webSection: $f64809aa9d8f3ca2$var$getWebSection(rawItem),
            parentSection: {
                label: section.label || section.styleClass
            }
        });
const $f64809aa9d8f3ca2$var$sortWebItems = (webItemA, webItemB)=>{
    if (!webItemA.weight || !webItemB.weight || !webItemA.label || !webItemB.label) return 0;
    if (webItemA.weight - webItemB.weight === 0) return webItemA.label.localeCompare(webItemB.label);
    else return webItemA.weight - webItemB.weight;
};
const $f64809aa9d8f3ca2$var$getWebSection = (item)=>{
    if (item.section && item.section.indexOf('/') !== -1) {
        const parts = item.section.split('/');
        return parts[1];
    }
};
const $f64809aa9d8f3ca2$var$getParamsObject = (item)=>{
    const paramObj = {};
    item.params?.forEach((param)=>{
        if (param?.key) paramObj[param.key] = param.value ?? '';
    });
    return paramObj;
};

});

parcelRegister("80koo", function(module, exports) {

$parcel$export(module.exports, "RequireLegacyWRM", () => $c65634971abef8c1$export$c2019f6d43c6c1ce);

var $gwFzn = parcelRequire("gwFzn");

var $cpjd2 = parcelRequire("cpjd2");
const $c65634971abef8c1$export$c2019f6d43c6c1ce = ({ wrm: wrm, children: children })=>{
    const [wrmLoadingState, setWrmLoadingState] = (0, $gwFzn.useState)({
        loaded: false,
        modules: []
    });
    (0, $gwFzn.useEffect)(()=>{
        (0, $cpjd2.requireLegacyWRM)(wrm, (modules)=>{
            setWrmLoadingState({
                loaded: true,
                modules: modules
            });
        }, ()=>{});
    }, [
        wrm
    ]);
    return wrmLoadingState.loaded && children ? children(wrmLoadingState.modules) : null;
};

});


//# sourceMappingURL=EditorByLineArea.8d14103d.js.map
